import { useCallback } from 'react';
import styled from 'styled-components';

import {
  InlineLoader,
  PredictiveTextField,
} from '@soluto-private/mx-asurion-ui-react';

import { type Suggestion } from '@service-initiation/shared-data-access-google';

const ValidationErrorText = styled.div`
  margin: 6px;
`;

export type LocationInputProps = {
  handleTextChange: (s: string) => void;
  hasValidationError?: boolean;
  inputText: string;
  loading: boolean;
  onLocationSelect: (place: Suggestion) => void;
  predictions: Suggestion[] | undefined;
  textFieldLabel: string;
  validationErrorText?: JSX.Element | string;
};

export const LocationInput = ({
  handleTextChange,
  hasValidationError,
  inputText,
  loading,
  onLocationSelect,
  predictions,
  textFieldLabel,
  validationErrorText,
}: LocationInputProps) => {
  const ValidationHelperText = useCallback(() => {
    if (!hasValidationError) return null;

    return (
      <ValidationErrorText data-testid="helper-text">
        {validationErrorText}
      </ValidationErrorText>
    );
  }, [validationErrorText, hasValidationError]);

  return (
    <>
      <PredictiveTextField
        alertNoResults={false}
        autoFocus={false}
        data-testid="zip-code-text-field"
        disabled={loading}
        fieldStatus={hasValidationError ? 'error' : 'default'}
        handleChange={(s: string) => handleTextChange(s)}
        iconSrc={
          loading ? (
            <InlineLoader disabled={true} width="1.5rem" />
          ) : (
            'location-pin'
          )
        }
        label={textFieldLabel}
        onSelection={onLocationSelect}
        shouldFocusFirstItem={true}
        style={{ color: 'black' }}
        suggestions={predictions && [...predictions]}
        value={inputText}
      />
      {hasValidationError && <ValidationHelperText />}
    </>
  );
};
